const CART_VALIDATION = {
  properties: {
    contact_email: {
      type: 'string',
      format: "email",
      minLength: 5,
      maxLength: 50
    },
    contact_name: {
      type: 'string',
      minLength: 1,
      maxLength: 30
    },
    contact_phone: {
      type: 'string',
      minLength: 10,
      maxLength: 20
    },
    customer_po: {
      type: 'string',
      maxLength: 15,
    },
    comments: {
      type: 'string',
      maxLength: 150
    },
  },
  required: [
    'contact_email',
    'contact_name',
    'contact_phone',
    'ship_to_address',
    'bill_to_address',
  ]
}

export default {
  DROPSHIP_WORDING: '',
  RETAILERS_ONLY_BUTTON_TEXT: '',
  COMING_SOON_BUTTON_TEXT: '',
  IS_SHOW_AVAILABILITY_IN_BIG_CART_LIST: false,
  IS_SHOW_ITEM_IN_CART_IN_RESULTS: false,
  IS_AUTO_SELECT_CHEAPEST_SHIPPING_METHOD: false,
  // filter out these shipping keys when autoselecting cheapest method.
  AUTO_SELECT_CHEAPEST_SHIPPING_METHOD_IGNORE_KEYS: ['PID'],

  // show documents linked to the product in the image carousel as links.
  IS_SHOW_DOCUMENTS_IN_PRODUCT_IMAGE_CAROUSEL: false,

  // fallback to to showing documents linked to the product's brand
  // in the image carousel if the product does not have any linked documents
  IS_CAROUSEL_DOCUMENTS_FALLBACK: false,

  // fallback to to showing videos linked to the product's brand in the image carousel
  // if the product does not have any linked videos
  IS_CAROUSEL_VIDEO_FALLBACK: false,

  // show or hide the aside on the right product information of the product detail page
  IS_SHOW_PRODUCT_DETAIL_RIGHT_SIDEBAR: true,

  // by default, collapse long descriptions
  IS_COLLAPSE_MX_CATEGORY_DESCRIPTION: true,

  // optional brand logo shown in the mx-category heading and on product detail.
  // empty string hides it.
  BRAND_LOGO_IMAGE: '',

  IS_SHOW_BILL_OF_MATERIALS_CONTENTS_IN_PRODUCT_DETAIL: false,

  // create customer default
  IS_REGISTER_DEFAULT: false,

  // show cart reference number on thank you page
  IS_SHOW_THANK_YOU_CART_REFERENCE: true,
  CART_VALIDATION,

  // carriers to allow for "Carrier-Quoted" shipping option
  CARRIERS: {
    ups: 'UPS',
    fedex: 'FedEx',
    dhl: 'DHL',
    other: 'Other',
  }
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/components/global/constants.js